// src/crm/conversations/useAddManualMessage.ts
import { useMutation, type QueryClient } from '@tanstack/react-query'
import { api } from '../../lib/api'
import type { Message, MessageChannel, MessageDirection } from '../../lib/types'

export type AddManualMessageInput = {
  creatorId: string
  channel: MessageChannel
  direction: MessageDirection
  subject?: string | null
  body: string
}

export function useAddManualMessage(creatorId: string | null, queryClient: QueryClient) {
  return useMutation({
    mutationFn: (data: AddManualMessageInput) =>
      api.post<{ message: Message }>('/api/messages', data).then((r) => r.message),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['conversation', creatorId] })
    },
  })
}
